<template>
    <div class="white-button trademark-button" :class="{ active: isFilterActive }">
        <button
            type="button"
            class="text-uppercase-based-on-eshop shop-button"
            :class="{ 'disabled-cursor': !currentFilteredColoredProducts.length }"
            @click="currentFilteredColoredProducts.length ? setFilter() : ''"
            :title="!currentFilteredColoredProducts.length ? __('frontend_js.category.no-products-via-filter') : ''"
        >
            <span>{{ category.special_title ? category.special_title : category.title }}</span>
            <span v-if="canViewCount"> ({{ currentFilteredColoredProducts.length }}) </span>
        </button>
    </div>
</template>

<script>
import collect from 'collect.js';

export default {
    props: {
        category: { required: true },
        canViewCount: { required: false },
    },

    data() {
        return {
            categoryColoredProducts: [],
        };
    },

    computed: {
        filters() {
            return this.$store.getters['product-filters/filters'];
        },
        isFilterActive() {
            return this.filters.categories.includes(this.category.id);
        },
        currentFilteredColoredProducts() {
            return this.categoryColoredProducts.filter(coloredProduct => {
                for (const key in this.filters) {
                    if (this.filters[key].length == 0) continue;
                    if (key == 'categories') continue;
                    if (collect(this.filters[key]).intersect(coloredProduct[key]).count() == 0) return false;
                }

                return true;
            });
        },
    },

    created() {
        this.categoryColoredProducts = this.$store.getters['product-filters/filterData'].categories.find(
            category => category.id == this.category.id
        ).coloredProducts;
    },

    methods: {
        setFilter() {
            this.$store.commit('product-list/SET_LOADING', true);

            setTimeout(() => {
                this.$store.commit('product-filters/SET_FILTER', {
                    key: 'categories',
                    value: [this.category.id],
                });

                setTimeout(() => {
                    this.$root.$emit('filterChanged');
                }, 10);
            }, 10);
        },
    },
};
</script>

<style lang="scss" scoped></style>
